import AnnouncementListLoader from './parts/Loaders/AnnouncementListLoader';
import AnnouncementTable from './parts/AnnouncementTable';

function AnnouncementList() {
  return (
    <AnnouncementListLoader>
      <AnnouncementTable />
    </AnnouncementListLoader>
  );
}

export default AnnouncementList;
